import * as crypto from "crypto-js"

export const generateSecretKey = (str: string): string => String(crypto.AES.encrypt(str, "key"))
